/*处理会员标签超出展示内容*/
export const formatTags = ({ row }) => {
    const list = row?.tagList || []
    // 支持 item 为对象或字符串，且过滤掉空值
    return list
        .map(item => (typeof item === 'string' ? item : item?.tagName ?? ''))
        .filter(Boolean)
        .join(', ') || '—'
}
